import { useMutation, useQueryClient } from 'react-query';
import { SCHOOL_SHIFT_KEYS } from 'services/SchoolShift/hooks/useQuery';
import {
  createSchoolClassAsync,
  deleteSchoolClassAsync,
  getAllSchoolClassByLicenseAsync,
  getSchoolClassByIdAsync,
  updateSchoolClassAsync,
} from '../../index';

export const useCreateSchoolClassAsync = () => {
  const queryClient = useQueryClient();
  return useMutation(createSchoolClassAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL]);
    }
  });
};

export const useUpdateSchoolClassAsync = () => {
  const queryClient = useQueryClient();
  return useMutation(updateSchoolClassAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL]);
    }
  });
};

export const useDeleteSchoolClassAsync = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteSchoolClassAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SCHOOL_SHIFT_KEYS.ALL]);
    }
  });
};

export const useGetSchoolClassByIdAsync = () =>
  useMutation(getSchoolClassByIdAsync);

export const useGetAllSchoolClassByLicenseAsync = () =>
  useMutation(getAllSchoolClassByLicenseAsync);
